import React, { useState, useEffect } from "react";

const BranchModal = ({ show, handleClose, branch, handleSave }) => {
    const [formData, setFormData] = useState({
        name: "",
        address: "",
        city: ""
    });

    useEffect(() => {
        if (branch) {
            setFormData({
                name: branch.name || "",
                address: branch.address || "",
                city: branch.city || ""
            });
        } else {
            setFormData({ name: "", address: "", city: "" });
        }
    }, [branch]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        handleSave(formData);
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white w-full max-w-xl mx-auto rounded-2xl shadow-lg p-6 md:p-8">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-lg font-semibold text-gray-800">
                        {branch ? "Edit Branch" : "Add Branch"}
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-400 hover:text-gray-700 text-xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Form */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {branch && (
                        <div className="md:col-span-2">
                            <label className="text-sm text-gray-600 mb-1 block">Branch ID</label>
                            <input
                                name="id"
                                value={branch.id}
                                readOnly
                                className="w-full px-4 py-2 rounded-md border bg-gray-100 text-sm"
                            />
                        </div>
                    )}

                    <div className="md:col-span-2">
                        <label className="text-sm text-gray-600 mb-1 block">Branch Name</label>
                        <input
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter branch name"
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="md:col-span-2">
                        <label className="text-sm text-gray-600 mb-1 block">Address</label>
                        <input
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Enter branch address"
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="md:col-span-2">
                        <label className="text-sm text-gray-600 mb-1 block">City</label>
                        <input
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            placeholder="Enter city"
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                </div>

                {/* Buttons */}
                <div className="mt-6 flex justify-end gap-3">
                    <button
                        onClick={handleClose}
                        className="px-5 py-2 text-sm bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-6 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                    >
                        {branch ? "Update" : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BranchModal;